export default __webpack_public_path__ + "static/gr-31b1f1c76effc7719b8f08b78418b0d5.svg";